import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { App } from './App';
import { preloadPage } from './routes';
import { store } from './store/store';
import './index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html');

const start = () =>
  createRoot(container).render(
    <StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </StrictMode>
  );

/*
 * A page that arrived as HTML stays on screen, readable and with working links, until
 * its code is here too. Rendering at once put the loading logo in its place for the
 * moment the page's chunk took to download — on every visit from a search result.
 */
const pending = container.hasChildNodes() ? preloadPage(window.location.pathname) : undefined;
if (pending) void pending.then(start, start);
else start();
